import { MetricsEvent } from "./metrics";

export const sendToTiktokPixel = (event: MetricsEvent) => {
  if (typeof window === "undefined") return;
  if (typeof (window as any).ttq !== "object") return;

  const ttq = (window as any).ttq;
  switch (event.type) {
    case "add_to_cart": {
      const payload = event.data;

      ttq.track("AddToCart", {
        content_id: payload.product?.id,
        content_type: 'product'
      });
      break;
    }

    case "begin_checkout": {
      const payload = event.data;

      ttq.track("InitiateCheckout", {
        content_id: payload?.userId,
        content_type: 'product',
        value: payload.total,
        currency: 'KZT'
      });
      break;
    }
      
    case "purchase": {
      const payload = event.data;

      ttq.track("Purchase", {
        content_id: payload.orderId,
        value: payload?.value ?? 0,
        currency: 'KZT'
      });
      break;
    }
  }
};